import { TFunction } from "i18next";

import { localeAr } from "@mobiscroll/react";
import { localeBg } from "@mobiscroll/react";
import { localeCa } from "@mobiscroll/react";
import { localeCs } from "@mobiscroll/react";
import { localeDa } from "@mobiscroll/react";
import { localeDe } from "@mobiscroll/react";
import { localeEl } from "@mobiscroll/react";
import { localeEn } from "@mobiscroll/react";
import { localeEs } from "@mobiscroll/react";
import { localeFa } from "@mobiscroll/react";
import { localeFi } from "@mobiscroll/react";
import { localeFr } from "@mobiscroll/react";
import { localeHe } from "@mobiscroll/react";
import { localeHi } from "@mobiscroll/react";
import { localeHr } from "@mobiscroll/react";
import { localeHu } from "@mobiscroll/react";
import { localeIt } from "@mobiscroll/react";
import { localeJa } from "@mobiscroll/react";
import { localeKo } from "@mobiscroll/react";
import { localeLt } from "@mobiscroll/react";
import { localeNl } from "@mobiscroll/react";
import { localeNo } from "@mobiscroll/react";
import { localePl } from "@mobiscroll/react";
import { localeRo } from "@mobiscroll/react";
import { localeRu } from "@mobiscroll/react";
import { localeSk } from "@mobiscroll/react";
import { localeSr } from "@mobiscroll/react";
import { localeSv } from "@mobiscroll/react";
import { localeTh } from "@mobiscroll/react";
import { localeTr } from "@mobiscroll/react";
import { localeVi } from "@mobiscroll/react";
import { localeZh } from "@mobiscroll/react";

export const getDatePicketLocales = (t: TFunction) => {
  return {
    dayNames: [
      t("ROOSTER.CALENDAR.SUNDAY", { defaultValue: "Sunday" }),
      t("ROOSTER.CALENDAR.MONDAY", { defaultValue: "Monday" }),
      t("ROOSTER.CALENDAR.TUESDAY", { defaultValue: "Tuesday" }),
      t("ROOSTER.CALENDAR.WEDNESDAY", {
        defaultValue: "Wednesday"
      }),
      t("ROOSTER.CALENDAR.THURSDAY", {
        defaultValue: "Thursday"
      }),
      t("ROOSTER.CALENDAR.FRIDAY", { defaultValue: "Friday" }),
      t("ROOSTER.CALENDAR.SATURDAY", { defaultValue: "Saturday" })
    ],
    dayNamesShort: [
      t("ROOSTER.CALENDAR.SUN", { defaultValue: "Sun" }),
      t("ROOSTER.CALENDAR.MON", { defaultValue: "Mon" }),
      t("ROOSTER.CALENDAR.TUE", { defaultValue: "Tue" }),
      t("ROOSTER.CALENDAR.WED", { defaultValue: "Wed" }),
      t("ROOSTER.CALENDAR.THU", { defaultValue: "Thu" }),
      t("ROOSTER.CALENDAR.FRI", { defaultValue: "Fri" }),
      t("ROOSTER.CALENDAR.SAT", { defaultValue: "Sat" })
    ],
    monthNames: [
      t("ROOSTER.CALENDAR.JANUARY", { defaultValue: "January" }),
      t("ROOSTER.CALENDAR.FEBRUARY", {
        defaultValue: "February"
      }),
      t("ROOSTER.CALENDAR.MARCH", { defaultValue: "March" }),
      t("ROOSTER.CALENDAR.APRIL", { defaultValue: "April" }),
      t("ROOSTER.CALENDAR.MAY", { defaultValue: "May" }),
      t("ROOSTER.CALENDAR.JUNE", { defaultValue: "June" }),
      t("ROOSTER.CALENDAR.JULY", { defaultValue: "July" }),
      t("ROOSTER.CALENDAR.AUGUST", { defaultValue: "August" }),
      t("ROOSTER.CALENDAR.SEPTEMBER", {
        defaultValue: "September"
      }),
      t("ROOSTER.CALENDAR.OCTOBER", { defaultValue: "October" }),
      t("ROOSTER.CALENDAR.NOVEMBER", {
        defaultValue: "November"
      }),
      t("ROOSTER.CALENDAR.DECEMBER", { defaultValue: "December" })
    ],
    monthNamesShort: [
      t("ROOSTER.CALENDAR.JAN", { defaultValue: "Jan" }),
      t("ROOSTER.CALENDAR.FEB", { defaultValue: "Feb" }),
      t("ROOSTER.CALENDAR.MAR", { defaultValue: "Mar" }),
      t("ROOSTER.CALENDAR.APR", { defaultValue: "Apr" }),
      t("ROOSTER.CALENDAR.MAY_SHORT", { defaultValue: "May" }),
      t("ROOSTER.CALENDAR.JUN", { defaultValue: "Jun" }),
      t("ROOSTER.CALENDAR.JUL", { defaultValue: "Jul" }),
      t("ROOSTER.CALENDAR.AUG", { defaultValue: "Aug" }),
      t("ROOSTER.CALENDAR.SEP", { defaultValue: "Sep" }),
      t("ROOSTER.CALENDAR.OCT", { defaultValue: "Oct" }),
      t("ROOSTER.CALENDAR.NOV", { defaultValue: "Nov" }),
      t("ROOSTER.CALENDAR.DEC", { defaultValue: "Dec" })
    ]
  };
};

/**
 * Maps i18next language codes to mobiscroll supported locales
 * Based on mobiscroll's supported locales: https://docs.mobiscroll.com/languages
 */
// Import locales from mobiscroll

type MobiscrollLocale = typeof localeEn;
const mobiscrollLocaleMap: Record<string, MobiscrollLocale> = {
  ar: localeAr,
  bg: localeBg,
  ca: localeCa,
  cs: localeCs,
  da: localeDa,
  de: localeDe,
  el: localeEl,
  en: localeEn,
  es: localeEs,
  fa: localeFa,
  fi: localeFi,
  fr: localeFr,
  he: localeHe,
  hi: localeHi,
  hr: localeHr,
  hu: localeHu,
  it: localeIt,
  ja: localeJa,
  ko: localeKo,
  lt: localeLt,
  nl: localeNl,
  no: localeNo,
  pl: localePl,
  ro: localeRo,
  ru: localeRu,
  sk: localeSk,
  sr: localeSr,
  sv: localeSv,
  th: localeTh,
  tr: localeTr,
  vi: localeVi,
  zh: localeZh
};

/**
 * Gets the appropriate locale for mobiscroll based on the language code
 * If no direct match is found, returns custom localization using i18next
 * @param t Translation function from i18next
 * @param languageCode Current language code
 * @returns Mobiscroll locale object
 */
export const getMobiscrollLocale = (t: TFunction, languageCode = "en") => {
  const baseLanguage = languageCode?.split("-")?.[0]?.toLowerCase();
  const mobiscrollLocale = mobiscrollLocaleMap?.[baseLanguage];

  if (mobiscrollLocale) {
    // Return the locale name to let mobiscroll use its built-in locale
    return mobiscrollLocale;
  }

  // Fall back to custom localization if the language is not supported
  return getDatePicketLocales(t);
};
